import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter, Youtube, MapPin, Phone, Mail, Clock } from "lucide-react";
import { COMPANY, LOGO_URL, CATEGORIES } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-zinc-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <img src={LOGO_URL} alt="Design Plus" className="h-16 w-auto mb-4 bg-white/5 rounded p-2" />
          <p className="text-sm text-zinc-400 leading-relaxed">Independent print shop in Fort Lauderdale. Heavy stock, sharp color and humans who pick up the phone.</p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-rose-500 flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-rose-500 flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-rose-500 flex items-center justify-center transition-colors"><Twitter className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-rose-500 flex items-center justify-center transition-colors"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Shop</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}><Link to={`/category/${c.slug}`} className="text-zinc-400 hover:text-rose-400 transition-colors">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Customer Care</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-zinc-400 hover:text-rose-400 transition-colors">About Us</Link></li>
            <li><Link to="/quote" className="text-zinc-400 hover:text-rose-400 transition-colors">Request a Quote</Link></li>
            <li><Link to="/shipping" className="text-zinc-400 hover:text-rose-400 transition-colors">Shipping Info</Link></li>
            <li><Link to="/returns" className="text-zinc-400 hover:text-rose-400 transition-colors">Reprint Promise</Link></li>
            <li><Link to="/promo" className="text-zinc-400 hover:text-rose-400 transition-colors">Monthly Promo</Link></li>
            <li><Link to="/contact" className="text-zinc-400 hover:text-rose-400 transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4 text-sm tracking-wider uppercase">Contact</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" /><span>{COMPANY.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" /><a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-white">{COMPANY.phone}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a></li>
            <li className="flex gap-3"><Clock className="w-4 h-4 text-rose-400 shrink-0 mt-0.5" /><span>{COMPANY.hours}</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between text-xs text-zinc-500">
          <p>© {new Date().getFullYear()} Design Plus. All rights reserved. Independent print studio in Fort Lauderdale, FL.</p>
          <div className="flex gap-5 mt-2 md:mt-0">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
